<template>
  <div class="w-full h-full">
    <div class="flex flex-col text-left divide-y h-full">
      <div class="py-2 text-center">
        <p class="font-bold text-lg text-center">Payment Contribution</p>
      </div>
      <PeachPayment v-if="paymentMethod === 'EFT' || paymentMethod === 'CARD'" />

      <div v-if="isDebiCheck" class="text-center pt-[10%] align-center">
        <p class="text-center text-gray-400 mb-2">
          Debicheck payment method is not supported at this moment. Please change your payment method or contact
          <a href="mailto:support@layup.co.za" class="text-brand-600">support</a>.
        </p>

        <LayupButton :label="'Go to Dashboard'" :isLoading="false" @click="goToDashboard" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LayupButton from '@/components/common/LayupButton.vue';
import { BASE_URL } from '@/config';
import { useGeneralStore } from '@/stores/general';
import { useWidgetStore } from '@/stores/widget';
import { addMetric } from '@/utils/monitoring.utils';
import { useRoute } from 'vue-router';
import PeachPayment from './PeachPayment.vue';

const route = useRoute();
const widgetStore = useWidgetStore();
const generalStore = useGeneralStore();

const goToDashboard = () => {
  window.location.href = `${BASE_URL}/shopper`;
};

const { amount, paymentMethod } = route.query;
const isDebiCheck = paymentMethod !== 'CARD' && paymentMethod !== 'EFT';
let paymentAmount: number | undefined = parseFloat(amount?.toString() || '0');
const paymentPlan = widgetStore.getPaymentPlan();
if (widgetStore.order.state === 'PARTIAL') paymentAmount = paymentPlan?.depositDue;
if (paymentPlan && paymentMethod && paymentAmount) {
  widgetStore.amountDue = paymentAmount;
  widgetStore.id = paymentPlan._id!;
  addMetric('payment_link', { channel: 'widget' });
  generalStore.reset();
} else {
  generalStore.reset();
  widgetStore.reset();
  goToDashboard();
}
</script>

<style scoped></style>
